import { isValidEmail } from '../../../variables/functions'
import { SpinLoader } from '../../Loader/SpinLoader'
import { createBookingPackagePublic } from 'apiCalls/BookingPackageRequests'
import { createBookingPublic } from 'apiCalls/BookingRequests'
import { patchPackagePublic } from 'apiCalls/PackageRequests'
import { fetchDirectChargeCheckoutSession } from 'apiCalls/StripeRequests'
import axios from 'axios'
import { PublicPackageButton } from 'components/public/MessageHandler'
import { Event } from 'components/trackers/Tracking'
import { publicBookingSubmitValidation } from 'components/validation/BookingInfoValidation'
import { useAppContext } from 'context/AppContext'
import moment from 'moment'
import React, { useState, useEffect } from 'react'
import { MdKeyboardArrowLeft } from 'react-icons/md'
import styled, { css } from 'styled-components'
import { stripeKey } from 'configs'
import { PUBLIC_LINK_BASE } from 'variables/general'
import { getPublicPackage } from 'apiCalls/PackageRequests'
import PackageAddOnSelection from '../../admin/bookings/PackageAddOnSelection'

var ts = require('@mapbox/timespace')

export default function BookingRequestMiniSession({
  values,
  handleChange,
  id,
  pack,
  deposit,
  font,
  secondaryFont,
  addOns,
  setAddOns,
  isForPreview,
  colorObj,
  packageForm,
  showForm,
  handleChangeWithPackageForm,
}) {
  const [page, setPage] = useState(1)
  const source = axios.CancelToken.source()
  const [selectedDate, setSelectedDate] = useState('')
  const [selectedTime, setSelectedTime] = useState('')
  const [errors, setErrors] = useState({})
  const [stripePromise, setStripePromise] = useState(null)
  const [stripeAPI, setStripeAPI] = useState(null)
  const [, dispatch] = useAppContext()
  const [sessionId, setSessionId] = useState(null)
  const [booking, setBooking] = useState(false)
  const [timeSlots, setTimeSlots] = useState(null)
  const [waitingForResponse, setWaitingForResponse] = useState(false)
  const [disableSubmit, setDisableSubmit] = useState(false)
  const [stripeRedirecting, setStripeRedirecting] = useState(false)
  const [blockSubmit, setBlockSubmit] = useState(false)

  const miniObj = JSON.parse(pack.miniSessions)

  let amount_payable

  let packDeposit = Math.round(pack.depositFraction * pack.price)

  if (pack.depositFraction < 0.01) {
    packDeposit = pack.price
  }

  if (addOns) {
    const addOnTotal = addOns
      .filter((addOn) => addOn.addedToOrder)
      .reduce((acc, curr) => {
        return acc + parseFloat(curr.packageAddOnTemplate.price)
      }, 0)

    amount_payable =
      Math.abs(packDeposit - pack.price) <= 0.1
        ? Math.round(
            (parseFloat(packDeposit) + parseFloat(addOnTotal)) *
              100 *
              (1 + parseFloat(pack.photographer.taxRate)),
          ) / 100
        : Math.round((parseFloat(packDeposit) + parseFloat(addOnTotal)) * 100) / 100
  } else {
    amount_payable =
      Math.abs(packDeposit - pack.price) <= 0.1
        ? Math.round(parseFloat(packDeposit) * 100 * (1 + parseFloat(pack.photographer.taxRate))) / 100
        : Math.round(parseFloat(packDeposit) * 100) / 100
  }

  const parseBookingAddOns = (addons) => {
    let parsedAddOns = []
    addons.forEach((addon) => {
      parsedAddOns.push({
        name: addon.packageAddOnTemplate.name,
        price: addon.packageAddOnTemplate.price,
        addedToOrder: addon.addedToOrder,
        quantity: 1,
      })
    })
    return parsedAddOns
    //TODO add error handling/sentry
  }

  // filter zero time slots date
  let dateData = miniObj.data
    .filter((el) => el.timeSlots.length !== 0)
    .map((el) => {
      return { date: el.date, timeSlots: el.timeSlots, ms: new Date(el.date).getTime() }
    })

  dateData.sort((a, b) => a.ms - b.ms)

  const handleSelectChange = (e) => {
    // Date
    setSelectedDate(e.target.value)

    const filterTimeSlots = dateData.filter((el) => el.date === e.target.value)[0].timeSlots
    setTimeSlots(filterTimeSlots)
  }

  const handleTimeSlot = (targetTime) => {
    // time slot object
    setSelectedTime(targetTime)
    setPage(2)
  }

  useEffect(() => {
    import('@stripe/stripe-js').then((func) => {
      setStripeAPI(func)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!!showForm && (showForm === 7 || showForm.length > 1)) {
      setPage(2)
    } else {
      setPage(1)
    }
  }, [showForm])

  const submit = () => {
    if (blockSubmit) return

    setBlockSubmit(true)
    setTimeout(() => {
      setBlockSubmit(false)
    }, 3000)
    setWaitingForResponse(true)
    const startDateTime = new moment(selectedTime.timeMin)

    const convertStartDateTime = startDateTime.tz(
      ts
        .getFuzzyLocalTimeFromPoint(new moment(selectedTime.timeMin).unix() * 1000, [
          pack.photographer.location.longitude,
          pack.photographer.location.latitude,
        ])
        .tz(),
      true,
    )
    const principalEmail = packageForm.filter((el) => el.fieldType === 5)[0].fieldValue
    const principalName = packageForm.filter((el) => el.fieldType === 1)[0].fieldValue
    const principalPhone = packageForm.filter((el) => el.fieldType === 4)[0].fieldValue
    const principalMessage = packageForm.filter((el) => el.fieldType === 2)[0].fieldValue

    const body = {
      memo: principalMessage || null,
      location: 'Victoria',
      meetingPlace: miniObj.location,
      customer: {
        email: principalEmail,
        name: principalName,
      },
      startDatetime: convertStartDateTime.unix(),
      taxRate: pack.photographer.taxRate,
      price: pack.price,
      contactPhoneNumber: principalPhone,
      depositFraction: pack.depositFraction,
      bookingAddOns: parseBookingAddOns(addOns),
      messageJson: JSON.stringify(packageForm),
      futureEmails: [
        {
          title: 'Retainer Amount',
          paymentAmount: amount_payable,
          sendAt: new Date(moment().add(1, 'day').format('YYYY-MM-DD HH:mm')),
        },
      ],
    }

    // VALIDATE SUBMITTED DATA
    let errors1 = publicBookingSubmitValidation({}, packageForm)
    setErrors(errors1)

    if (Object.values(errors1).length > 1) {
      dispatch({
        type: 'setAlertType',
        alertType: 'error',
      })
      dispatch({
        type: 'setAlertText',
        alertText: Object.values(errors1),
      })//

      setWaitingForResponse(false)
      setDisableSubmit(false)
      setStripeRedirecting(false)
      return
    }

    if (!isValidEmail(pack.photographerEmail, values.email)) {
      dispatch({
        type: 'setAlertType',
        alertType: 'error',
      })
      dispatch({
        type: 'setAlertText',
        alertText: ['This email cannot be used, please use another'],
      })
      return
    }

    createBookingPublic(source, body, pack.identifier).then((response) => {
      if (response.status === 201) {
        setBooking(response.data)

        const booking_package_data = {
          title: pack.title,
          category: pack.category,
          hoursOfCoverage: pack.hoursOfCoverage,
          licenseType: pack.licenseType,
          description: pack?.description,
          whatsIncluded: pack.whatsIncluded,
          whatToExpect: pack.whatToExpect,
          price: pack.price,
          depositFraction: pack.depositFraction,
          cancellationPolicy: pack.cancellationPolicy,
          extensionPolicy: pack.extensionPolicy,
          weatherPolicy: pack.weatherPolicy,
          licensePolicy: pack.licensePolicy,
          paymentSchedulePolicy: pack.paymentSchedulePolicy,
          addOnsPolicy: pack.addOnsPolicy,
          miniSessions: pack.miniSessions,
          messageJson: JSON.stringify(packageForm),
        }

        createBookingPackagePublic(source, booking_package_data, response.data.identifier).then(
          (response) => {
            if (response.status !== 201) {
              setWaitingForResponse(false)
              throw new Error(response.data)
            }
          },
        )

        const newMiniData = miniObj.data.map((el) => {
          if (el.date === selectedDate) {
            const findIndex = (element) => element.timeMin === selectedTime.timeMin
            let newSlots = [...el.timeSlots]
            let index = newSlots.findIndex(findIndex)
            newSlots[index] = { ...newSlots[index], booked: true }
            return { ...el, timeSlots: newSlots }
          } else {
            return el
          }
        })

        const body = {
          miniSessions: JSON.stringify({ location: miniObj.location, data: newMiniData }),
        }

        patchPackagePublic(pack.identifier, body, source).then((res) => {
          if (res.status === 200) {
            if (pack.photographer.stripeOnboardCompleted && stripeAPI) {
              stripeAPI
                .loadStripe(stripeKey, {
                  stripeAccount: `${pack.photographer.stripeUserId}`,
                })
                .then((response) => {
                  setStripePromise(response)
                })
              fetchDirectChargeCheckoutSession(response.data.identifier, amount_payable).then((response) => {
                setSessionId(response.data.checkoutSessionId)
                setWaitingForResponse(false)
              })
            } else {
              window.location.href = `${PUBLIC_LINK_BASE(pack.photographer)}/booking/${
                response.data.identifier
              }`
              setWaitingForResponse(false)
            }
          } else {
            dispatch({
              type: 'setAlertType',
              alertType: 'error',
            })
            dispatch({
              type: 'setAlertText',
              alertText: ['Booking created with error'],
            })
            setWaitingForResponse(false)
            throw new Error(`${res}`)
          }
        })
      } else {
        dispatch({
          type: 'setAlertType',
          alertType: 'error',
        })
        dispatch({
          type: 'setAlertText',
          alertText: ['Mini session booking could not be created'],
        })
        setWaitingForResponse(false)
        throw new Error(response.data)
      }
    })
  }

  // comment
  const checkTimeSlotBooked = () => {
    if (isForPreview) return

    setDisableSubmit(true)
    getPublicPackage(pack.identifier).then((response) => {
      if (response.status === 200) {
        // Fetch timeslot on selectedData from json mini object
        const newMiniObj = JSON.parse(response.data.miniSessions)

        const newDateData = newMiniObj.data
          .filter((el) => el.timeSlots.length !== 0)
          .map((el) => {
            return { date: el.date, timeSlots: el.timeSlots, ms: new Date(el.date).getTime() }
          })

        const newFilterTimeSlots = newDateData
          .sort((a, b) => a.ms - b.ms)
          .filter((el) => el.date === selectedDate)[0].timeSlots

        let canSubmit = false
        for (const element of newFilterTimeSlots) {
          if (
            element.timeMin === selectedTime.timeMin &&
            element.timeMax === selectedTime.timeMax &&
            !element.booked
          ) {
            canSubmit = true
          }
        }
        if (!!canSubmit) {
          submit()
        } else {
          dispatch({
            type: 'setAlertType',
            alertType: 'error',
          })
          dispatch({
            type: 'setAlertText',
            alertText: ['Time slot has been taken, please select another one. Page will refresh in a second'],
          })
          setDisableSubmit(false)
          setTimeout(() => {
            window.location.reload()
          }, 2000)
        }
      } else {
        dispatch({
          type: 'setAlertType',
          alertType: 'error',
        })
        dispatch({
          type: 'setAlertText',
          alertText: ['Failed fetching time slots data'],
        })
        setDisableSubmit(false)
      }
    })
  }

  useEffect(() => {
    const redirectToCheckout = async () => {
      if (stripePromise && sessionId) {
        try {
          setStripeRedirecting(true)
          // This will redirect the browser to the Stripe Checkout
          let { error } = await stripePromise.redirectToCheckout({
            sessionId,
          })
          if (error) {
            console.error('Stripe Checkout error:', error)
          }
          Event(
            'PAYMENT',
            `Booking ${booking.identifier} Paid -- $${booking.bill.amountDue}, ${pack.title} from ${booking.package.photographer.name}`,
            'Payment Through Stripe',
          )
        } catch (error) {
          console.error('Error redirecting to Stripe Checkout:', error)
        } finally {
          setStripeRedirecting(false)
        }
      }
    }

    redirectToCheckout()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stripePromise, sessionId])

  return (
    <Container>
      {page === 1 && (
        <SubContainer>
          <SubLabel color={colorObj?.text}>Available Dates</SubLabel>
          {dateData.length !== 0 ? (
            <Select
              value={selectedDate}
              onChange={(e) => handleSelectChange(e)}
              data-testid="select-date-mini-session"
            >
              <option value={''}>-- Please Select a Date --</option>
              {dateData.map((el, j) => {
                return (
                  <option value={el.date} key={`date-option${j + 1}`} data-testid={`date-option${j + 1}`}>
                    {new moment(el.date).format('MMM Do YYYY')}
                  </option>
                )
              })}
            </Select>
          ) : (
            <Select
              value={selectedDate}
              onChange={(e) => handleSelectChange(e)}
              data-testid="select-date-mini-session"
            >
              <option value={''}>-- No available dates --</option>
            </Select>
          )}
          {!!selectedDate && <SubLabel color={colorObj?.text}>Available Time Slots</SubLabel>}
          {!!selectedDate &&
            timeSlots.map((el, i) => {
              return !el.booked ? (
                <Spot
                  key={`timeslot-option${i + 1}`}
                  onClick={() => handleTimeSlot(el)}
                  isForPreview={isForPreview}
                  color={colorObj?.text}
                >
                  {` ${new moment(el.timeMin).format('h:mm a')} - ${new moment(el.timeMax).format('h:mm a')}`}
                </Spot>
              ) : (
                <Spot1 key={`timeslot-option${i + 1}`} color={colorObj?.text}>
                  {` ${new moment(el.timeMin).format('h:mm a')} - ${new moment(el.timeMax).format('h:mm a')}`}
                </Spot1>
              )
            })}
          <div>
            {' '}
            <Divider>Or</Divider>
            <PublicPackageButton
              companyName={pack.photographer.companyName}
              buttonTitle={isForPreview ? 'Book Now' : 'Contact Me'}
              option={'message'}
              photographerID={pack.photographer.identifier}
              interest={window.location.pathname}
              font={secondaryFont ? secondaryFont : font}
              isForPreview={isForPreview}
            />
          </div>
        </SubContainer>
      )}
      {page === 2 && (
        <SubContainer>
          <Form>
            <Label>
              Date & Time
              <Back
                onClick={() => {
                  setPage(1)
                }}
                page={2}
              >
                <LeftArrow />
                Back
              </Back>
            </Label>
            <SelectedDate>{`${new moment(selectedDate).format('MMM Do YYYY')},    ${new moment(
              selectedTime.timeMin,
            ).format('h:mm a')} - ${new moment(selectedTime.timeMax).format('h:mm a')}`}</SelectedDate>
            <Label>Information</Label>
            {!!packageForm ? (
              <FormContainer>
                {packageForm.slice(1).map((el, i) => {
                  return el?.fieldType === 2 ? (
                    <div key={'packageform' + i}>
                      {' '}
                      <SubLabel1>
                        {el?.fieldLabel}
                        {!!el?.required && ' *'}
                      </SubLabel1>
                      <TextArea
                        id={`booking-request-${i}`}
                        style={{ fontSize: '16px' }}
                        name={el?.fieldLabel}
                        type="text"
                        value={el?.fieldValue}
                        placeholder={el?.fieldPlaceHolder}
                        onChange={(e) => handleChangeWithPackageForm(e, i + 1)}
                        error={!!Object.keys(errors).includes(el.fieldLabel)}
                      />
                      {!!Object.keys(errors)?.includes(el?.fieldLabel) && (
                        <ErrorMsg>{errors[el?.fieldLabel]}</ErrorMsg>
                      )}
                    </div>
                  ) : (
                    <div key={'packageform' + i}>
                      <SubLabel1>
                        {el?.fieldLabel}
                        {!!el?.required && ' *'}
                      </SubLabel1>
                      <Input
                        id={`booking-request-${i}`}
                        style={{ fontSize: '16px' }}
                        name={el?.fieldLabel}
                        type="text"
                        value={el?.fieldValue}
                        placeholder={el?.fieldPlaceHolder}
                        onChange={(e) => handleChangeWithPackageForm(e, i + 1)}
                        error={!!Object.keys(errors).includes(el.fieldLabel)}
                      />
                      {!!Object.keys(errors)?.includes(el?.fieldLabel) && (
                        <ErrorMsg>{errors[el?.fieldLabel]}</ErrorMsg>
                      )}
                    </div>
                  )
                })}
              </FormContainer>
            ) : (
              <FormContainer>
                <div>
                  <SubLabel1>Name</SubLabel1>
                  <Input
                    id="booking-request-name"
                    style={{ fontSize: '16px' }}
                    name="name"
                    type="text"
                    value={values.name}
                    onChange={handleChange}
                    error={!!Object.keys(errors).includes('name')}
                  />
                  {!!Object.keys(errors).includes('name') && <ErrorMsg>{errors.name}</ErrorMsg>}
                </div>
                <div>
                  <SubLabel1>Email</SubLabel1>
                  <Input
                    id="booking-request-email"
                    style={{ fontSize: '16px' }}
                    name="email"
                    type="email"
                    value={values.email}
                    onChange={handleChange}
                    error={!!Object.keys(errors).includes('email')}
                  />
                  {!!Object.keys(errors).includes('email') && <ErrorMsg>{errors.email}</ErrorMsg>}
                </div>
                <div>
                  <SubLabel1>Phone</SubLabel1>
                  <Input
                    id="booking-request-phone"
                    style={{ fontSize: '16px' }}
                    name="phone"
                    type="text"
                    value={values.phone}
                    onChange={handleChange}
                    error={!!Object.keys(errors).includes('phone')}
                  />
                  {!!Object.keys(errors).includes('phone') && <ErrorMsg>{errors.phone}</ErrorMsg>}
                </div>
                <QuestionWrapper>
                  <SubLabel2>Message</SubLabel2>
                  {!!pack.placeholderMessage && <Question>{pack.placeholderMessage}</Question>}
                  <QInput
                    id="booking-request-note"
                    style={{ fontSize: '16px' }}
                    name="note"
                    type="text"
                    value={values.note}
                    onChange={handleChange}
                  />
                  {!!Object.keys(errors).includes('note') && <ErrorMsg>{errors.note}</ErrorMsg>}
                </QuestionWrapper>
              </FormContainer>
            )}
            {addOns && addOns.length > 0 && <H3 style={{ margin: '0px', padding: '0px' }}>Add - Ons</H3>}
            <PackageAddOnSelection setAddOns={setAddOns} addOns={addOns}></PackageAddOnSelection>
            <ButtonRow>
              {pack.photographer.stripeOnboardCompleted ? (
                <SubmitButton
                  disabled={waitingForResponse || disableSubmit || stripeRedirecting || isForPreview}
                  onClick={() => checkTimeSlotBooked()}
                  isForPreview={isForPreview}
                  background={colorObj?.accent1}
                >
                  {' '}
                  {waitingForResponse || disableSubmit || stripeRedirecting ? (
                    <SpinLoader size={28}></SpinLoader>
                  ) : (
                    <>
                      {`Pay ${
                        pack?.photographer?.overrideCurrencySymbol ?? pack.photographer.currencySymbol ?? '$'
                      }${amount_payable} ${
                        pack?.photographer?.overrideCurrencyCode?.toUpperCase() ??
                        pack?.photographer?.currencyCode?.toUpperCase() ??
                        ''
                      }`}
                    </>
                  )}
                </SubmitButton>
              ) : (
                <SubmitButton
                  disabled={waitingForResponse || stripeRedirecting || disableSubmit || isForPreview}
                  onClick={() => checkTimeSlotBooked()}
                  isForPreview={isForPreview}
                  background={colorObj?.accent1}
                >
                  {waitingForResponse ? <SpinLoader size={28}></SpinLoader> : 'Book Now'}
                </SubmitButton>
              )}
            </ButtonRow>
          </Form>
        </SubContainer>
      )}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
`
const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const Label = styled.label`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  color: var(--black);
  font-size: 18px;
  margin: 0.5em 0;
  line-height: 1.5;
`

const SubLabel = styled.label`
  font-size: 18px;
  color: ${(props) => (props.color ? props.color : 'var(--black)')};
  z-index: 2;
  margin: 15px 0 10px 0;
`

const SubLabel1 = styled.label`
  font-size: 12px;
  position: absolute;
  color: var(--dark-grey-2);
  z-index: 2;
  margin: 8px 0 0 8px;
`
const SubLabel2 = styled(SubLabel1)`
  position: relative;
`

const Select = styled.select`
  color: var(--dark-grey-1);
  font-size: 14px;
  border: 1px solid #dee2e6;
  border-radius: 5px;
  margin: 0 0 8px 0;
  height: 40px;
  padding: 8px 12px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-size: 10px;
  background-position: right 4px top 60%;
  @media (min-width: 576px) and (max-width: 1200px) {
    padding: 0 0 0 8px;
    background-position: right 8px top 60%;
  }
`

const Spot = styled.div`
  font-size: 14px;
  padding: 12px 0 12px 8px;
  border-bottom: 1px solid var(--form-grey);
  border-radius: none;
  color: ${(props) => (props.color ? props.color : 'var(--dark-grey-1)')};
  cursor: pointer;
  :hover {
    background-color: #fff;
  }
`

const Spot1 = styled(Spot)`
  text-decoration: line-through;
`

const Form = styled.div`
  padding: 0;
  font-size: 16px;
  font-family: inherit;
  ${(props) =>
    (props.page === 3 || props.page === 4) &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    `}
`

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const Input = styled.input`
  position: relative;
  width: 100%;
  margin: 0 0 0.5em 0;
  height: auto;
  padding: 2em 0.5em 0.5em 0.5em;
  font-size: 1rem;
  line-height: 1.5;
  color: var(--black);
  background-color: #fff;
  background-clip: padding-box;
  border: ${(props) => (props.error ? '1px solid var(--error)' : '1px solid var(--form-grey)')};
  border-radius: 0;
  box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);
  &:focus {
    border: 1px solid var(--forward);
  }
`

const ErrorMsg = styled.div`
  font-size: 12px;
  color: var(--error);
  margin: 0 0 0.5em 0;
`

const TextArea = styled.textarea`
  width: -webkit-fill-available;
  height: 200px;
  margin: 0 0 0.5em 0;
  padding: 2em 0.5em 0.5em 0.5em;
  z-index: 9;
  resize: none;
  font-size: 14px;
  color: var(--black);
  background-color: #fff;
  background-clip: padding-box;
  border: ${(props) => (props.error ? '1px solid var(--error)' : '1px solid var(--form-grey)')};
  overflow-y: scroll;
`

const QInput = styled.textarea`
  width: -webkit-fill-available;
  height: -webkit-fill-available;
  margin: 0 0 0 0.5em;
  padding: 0 0.5em 0 0;
  z-index: 9;
  resize: none;
  font-size: 14px;
  color: var(--black);
  background-color: #fff;
  background-clip: padding-box;
  border: none;
  overflow-y: scroll;
`

const Question = styled.div`
  z-index: 4;
  margin: 0.5em;
  background-color: #fafafa;
  padding: 0.5em;
  border-radius: 0.3em;
  font-size: 14px;
  width: auto;
`

const QuestionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 250px;
  margin: 0 0 0.5em 0;
  color: var(--black);
  background-color: #fff;
  background-clip: padding-box;
  border: ${(props) => (props.error ? '1px solid var(--error)' : '1px solid var(--form-grey)')};
  border-radius: 0.25rem;
  box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);
  &:focus {
    border: 1px solid var(--forward);
  }
  @media (max-width: 420px) {
    height: 300px;
  }
`

const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  margin: 1em 0 0 0;
  font-family: inherit;
`

const SubmitButton = styled.button`
  font-size: 16px;
  padding: 1em 1.5em;
  font-family: inherit;
  width: 100%;
  background-color: ${(props) =>
    !props.disabled ? (props.isForPreview ? props.background : 'var(--black)') : 'var(--light-grey)'};
`

const SelectedDate = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  border: 1px solid var(--light-grey-2);
  background-color: #f0f0f0;
  padding: 15px 8px;
  margin: 0 0 1em 0;
`

const Back = styled.div`
  display: flex;
  align-items: center;
  color: var(--dark-grey-2);
  font-size: 14px;
  cursor: pointer;
  margin: 0 0 1em 0;
  ${(props) =>
    props.page === 2 &&
    css`
      margin: 0;
    `}
  :hover {
    color: var(--dark-grey-1);
  }
`

const LeftArrow = styled(MdKeyboardArrowLeft)`
  font-family: inherit;
  color: inherit;
  margin: 2px 2px 0 -3px;
`

const Divider = styled.div`
  margin: 30px 0 0 0;
  padding: 0 0 20px 0;
  font-size: 22px;
  border-bottom: 1px solid var(--light-grey);
`

const H3 = styled.h3`
  color: var(--black);
  font-size: 1.2em;
  margin: 0 0 2em 0;
  @media (max-width: 500px) {
    font-size: 1em;
    font-weight: 400;
  }
`
